module.exports = __webpack_public_path__ + "img/ICONE-FLECHE.1da47dc3.svg";